import { render } from "./OrderCalculatorModal.vue?vue&type=template&id=10f0d1dd&scoped=true"
import script from "./OrderCalculatorModal.vue?vue&type=script&lang=js"
export * from "./OrderCalculatorModal.vue?vue&type=script&lang=js"

import "./OrderCalculatorModal.vue?vue&type=style&index=0&id=10f0d1dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f0d1dd"]])

export default __exports__